import { httpRequest } from "../../http.ts";

/**
 * Focused link setter (MPN-1483): points a data spec at a population without
 * round-tripping the whole definition. null unlinks. The server keeps the
 * legacy population_segment_name in step with the FK.
 */
export class CommandSetDefinitionSegment {
  async run(definitionId: number, populationSegmentId: number | null) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/ingest/definitions/${definitionId}/population-segment/`;
    return httpRequest<any>(url, {
      method: "PATCH",
      body: { population_segment_id: populationSegmentId },
    });
  }
}
